import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-065bd3d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cover" }
const _hoisted_2 = ["data-edit", "innerHTML"]

import { withDefaults } from 'vue';
import { vMove, vInput, useCover } from './index';
type Pos = {
  left: number;
  top: number;
  center?: boolean;
  initHeight?: number;
  left2right?: boolean;
};
const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="1196.282" height="1685.997" viewBox="0 0 1196.282 1685.997">
  <g transform="translate(1.001 0.998)">
    <path d="M16070.067-10112.748H15759.5V-10664H16238l-167.933,551.246Zm62.218,0h-6.273l174.935-574.244H15759.5V-10693h549.554l-1.179,3.874Z" transform="translate(-15760 11797.248)" fill="var(--theme-color-1)" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
    <path d="M17033.781-9767.5h-549.559l1.178-3.879,159.367-523.124h6.273L16492.33-9773.5h541.449l0,6.008Zm0-29.007h-478.5l151.709-498h326.793Z" transform="translate(-15839 10294)" fill="var(--theme-color-1)" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
  </g>
</svg>
`;


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-cover-9',
  props: {
    useEdit: { type: Boolean },
    projectName: {},
    time: {},
    mainPageEnterpriseName: {},
    titlePosition: {},
    settleTimePosition: {},
    aspNamePosition: {},
    orderNumber: {},
    orderNumberPostion: {}
  },
  emits: ['posChange', 'valueChange'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const { info, onPosChange, onValueChange } = useCover(emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info), (item, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        "data-edit": _ctx.useEdit,
        key: index,
        class: _normalizeClass({ [item.className]: true }),
        innerHTML: props[item.valueKey]
      }, null, 10, _hoisted_2)), [
        [_unref(vMove), {
        pos: props[item.posKey],
        change: (left, top) => _unref(onPosChange)(item.posKey, left, top)
      }],
        [_unref(vInput), {
        value: props[item.valueKey],
        change: (value) => _unref(onValueChange)(item.valueKey, value)
      }]
      ])
    }), 128)),
    _createElementVNode("div", {
      innerHTML: svg,
      class: "svg"
    })
  ]))
}
}

})